var Actions;
(function (Actions) {
    Actions["GET_ASSET_PROFILLING_CLASS_LIST"] = "getAssetProfillingClassList";
    Actions["GET_ASSET_PROFILLING_CLASS_LIST_CODE_DESC"] = "getAssetProfillingClassListIdDesc";
    Actions["CREATE_ASSET_PROFILLING_CLASS_LIST"] = "createAssetProfillingClassList";
    Actions["UPDATE_ASSET_PROFILLING_CLASS_LIST"] = "updateAssetProfillingClassList";
    Actions["GET_ASSET_PROFILLING_CLASS_LIST_FILTER"] = "getAssetProfillingClassListFilter";
    Actions["GET_ASSET_PROFILLING_CLASS_DATA"] = "getAssetProfillingClassData";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_CLASS_CODE"] = "updateSelectedAssetProfillingClassId";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_CLASS_DESC"] = "updateSelectedAssetProfillingClassDesc";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE"] = "updateSelectedAssetProfillingClassActive";
    Actions["UPDATE_ASSET_PROFILLING_CLASS_SIZE"] = "updateAssetProfillingClassSize";
    Actions["RESET_ASSET_PROFILLING_CLASS_FILTER"] = "resetAssetProfillingClassFilter";
    Actions["DOWNLOAD_ASSET_PROFILLING_CLASS"] = "downloadAssetProfillingClass";
    Actions["UPDATE_ASSET_PROFILLING_CLASS_PAGE_FILTER"] = "updateAssetProfilingClassPageFilter";
    Actions["UPDATE_SEARCH_ASSET_PROFILLING_CLASS_DESC"] = "updateSearchAssetProfillingClassDesc";
    Actions["UPDATE_SEARCH_ASSET_PROFILLING_CLASS_CODE"] = "updateSearchAssetProfillingClassCode";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_ASSET_PROFILLING_CLASS_WAS_FIRST_LOAD"] = "setAssetProfillingClassWasFirstLoad";
    Mutations["SET_ASSET_PROFILLING_CLASS_LOADING"] = "setAssetProfillingClassLoading";
    Mutations["SET_ASSET_PROFILLING_CLASS_HANDLE_PAGE"] = "setAssetProfillingClassHandlePage";
    Mutations["SET_ASSET_PROFILLING_CLASS_LIST"] = "setAssetProfillingClassList";
    Mutations["SET_ASSET_PROFILLING_CLASS_LIST_CODE"] = "setAssetProfillingClassListId";
    Mutations["SET_ASSET_PROFILLING_CLASS_LIST_DESC"] = "setAssetProfillingClassListDesc";
    Mutations["SET_ASSET_PROFILLING_CLASS_PAGE"] = "setAssetProfillingClassPage";
    Mutations["SET_ASSET_PROFILLING_CLASS_LOAD_PAGE"] = "setAssetProfillingClassLoadPage";
    Mutations["SET_SELECTED_ASSET_PROFILLING_CLASS_CODE"] = "setSelectedAssetProfillingClassId";
    Mutations["SET_SELECTED_ASSET_PROFILLING_CLASS_DESC"] = "setSelectedAssetProfillingClassDesc";
    Mutations["SET_SELECTED_ASSET_PROFILLING_CLASS_ACTIVE"] = "setSelectedAssetProfillingClassActive";
    Mutations["SET_ASSET_PROFILLING_CLASS_STATUS"] = "setAssetProfillingClassStatus";
    Mutations["SET_ASSET_PROFILLING_CLASS_SIZE"] = "setAssetProfillingClassSize";
    Mutations["SET_ASSET_PROFILLING_CLASS_USE_FILTER"] = "setAssetProfillingClassUseFilter";
    Mutations["SET_ASSET_PROFILLING_CLASS_PAGE_FILTER"] = "setAssetProfilingClassPageFilter";
    Mutations["SET_ASSET_PROFILLING_CLASS_WAS_LOAD_QUICK_FILTER"] = "setAssetProfilingClassWasLoadQuickFilter";
    Mutations["SET_ASSET_PROFILLING_CLASS_SEARCH_BY"] = "setAssetProfillingClassSearchBy";
    Mutations["SET_ASSET_PROFILLING_CLASS_SEARCH_KEY"] = "setAssetProfillingClassSearchKey";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
